import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import instance from "../../../config/Config";
import axios from "axios";

const initialState = {
  loading: false,
  leadData: null,
  conLead: null,
  error: null,
  response: null,
  singleLead: null,
  checkStatusLoading: false,
  alterData: null,
  convertLeadMessage: null,
  leadTrack: null,
  leadDesc: null,
  sourceList: null,
  noteList: null,
  callList: null,
  employee: null,
  projectsList: null,
  callingStatus: null,
  leadStatus: null,
  leadBalance: null,
  utmSource: null,
  leadRequestId: null
};

export const GetLeadData = createAsyncThunk("GetLeadData", async (body) => {
  try {
    const response = await instance.get(
      `/crm/leads/fetch-lead-data?page=${body?.currentPage}&search=${body?.search}&project=${body?.project}&source=${body?.source}&dateSource=${body?.dateSource}&remark=${body.remark}&NoActivity=${body.NoActivity}&priority=${body.priority}&assignto=${body.assignto}&remindFilter=${body?.remindDateFilter}&isRegisterFilter=${body?.isRegisterFilter}&startDate=${body.startDate}&endDate=${body.endDate}&category=${body.category}&lead_type=${body.lead_type}&utm_source=${body.utm_source}&row_per_page=${body.row_per_page}`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
});

export const AddLeadFile = createAsyncThunk("AddLeadFile", async (body) => {
  const formData = new FormData();
  formData.append("excelfile", body);
  try {
    const res = await instance.post("/crm/leads/upload-excel", formData);
    return res.data;
  } catch (error) {
    return error;
  }


});

export const getSingleLead = createAsyncThunk("GetSingleLead", async (id) => {
  try {
    const response = await instance.get(
      `/crm/leads/fetch-single-lead?id=${id}`
    );
    return response?.data;
  } catch (error) {
    return error;
  }
});

export const createLead = createAsyncThunk("CreateLead", async (body) => {
  try {

    const response = await instance.post("/crm/leads/create-lead", body);
    return response?.data;
  } catch (error) {
    return error;
  }
});
// -------------------------------------------------------------------------------------------CONNECT CALL------------------------------->>>>>>
// -------------------------------------------------------------------------------------------CONVERT LEAD------------------------------->>>>>>

export const convertLead = createAsyncThunk("convertLead", async (body) => {
  try {
    // debugger;
    const response = await instance.post("/crm/leads/convert-lead", body);
    return response?.data;
  } catch (error) {
    return error;
  }
});

export const fetchConvertedLeadOverview = createAsyncThunk(
  "fetchConvertedLeadOverview",
  async (projectId, { rejectWithValue }) => {
    try {
      const response = await instance.get(
        "/crm/leads/converted-lead-overview",
        {
          params: projectId ? { project_id: projectId } : {},
        },
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || {
          message: "Failed to fetch today's lead conversion summary.",
        },
      );
    }
  },
);
// -------------------------------------------------------------------------------------------CONVERT LEAD------------------------------->>>>>>

export const AddAlternativeNumber = createAsyncThunk("AddAlternativeNumber", async (body) => {
  try {
    const response = await instance.post(`/crm/leads/alternative-number-lead?l_lead=${body?.l_lead}`,
      body?.data);
    return response?.data;
  } catch (error) {
    return error;
  }
})

export const UpdateLead = createAsyncThunk("UpdateLead", async (body) => {
  try {

    const response = await instance.post(
      `/crm/leads/lead-update?id=${body?.id}&l_project=${body?.l_project}`,
      body?.data
    );
    return response?.data;
  } catch (error) {
    return error;
  }
});

export const UpdateReminderDate = createAsyncThunk(
  "UpdateReminderDate",
  async (body) => {
    try {
      const response = await instance.post(
        `/crm/leads/lead-reminder-date-update?id=${body?.id}`,
        body
      );
      return response?.data;
    } catch (error) {
      return error;
    }
  }
);

export const callCountUpdate = createAsyncThunk(
  "callCountUpdate",
  async (id) => {

    try {

      const response = await instance.get(`/crm/leads/call-update?id=${id}`);
      return response?.data;
    } catch (error) {
      return error;
    }
  }
);

export const checkStatusInstall = createAsyncThunk(
  "checkStatusInstall",
  async (body) => {
    try {
      const response = await instance.get(
        `/crm/leads/check-status-install?id=${body.id}&mobileNumber=${body.mobileNumber}&email=${body.email}`
      );
      return response?.data;
    } catch (error) {
      return error;
    }
  }
);

export const getHistory = createAsyncThunk("getHistory", async (body) => {
  try {
    const response = await instance.get(`/crm/leads/history?from=${body.startDate}&to=${body.endDate}`);
    return response?.data;
  } catch (error) {
    return error;
  }
});

//SEND MULTIPLE TEMPLATE--------

export const sendMultipleTemplate = createAsyncThunk(
  "sendMultipleTemplate",
  async (body) => {
    // let data = body.map((ele) => ele.l_contact);
    // let modyfyData = [...data];
    let newObj = { bulk_ids: body };

    try {

      const response = await instance.post(
        `/crm/whatsapp/send-template`,
        newObj
      );
      return response?.data;
    } catch (error) {
      return error;
    }
  }
);

// {Activity tracker of single lead}

export const fetchSingleLeadTrack = createAsyncThunk("fetchSingleLeadTrack", async (id) => {
  try {
    const response = await instance.get(`/crm/leads/fetch-single-lead?id=${id}`);
    return response?.data;
  } catch (error) {
    return error;
  }
})

export const AddLeadDescription = createAsyncThunk("AddLeadDescription", async (body) => {
  try {
    const response = await instance.post("/crm/leads/add-lead-desc", null, {
      params: {
        ld_lead_id: body?.ld_lead_id,
        ld_lead_description: body?.ld_lead_description,
      },
    });
    return response?.data;
  } catch (error) {
    return error;
  }
})

export const getSourceList = createAsyncThunk("getSourceList", async (body) => {
  try {
    const response = await instance.get(`/crm/leads/uniq-source-list`);
    return response?.data;
  } catch (error) {
    return error;
  }
});

export const fetchCmoEmployeeList = createAsyncThunk(
  "fetchCmoEmployeeList",
  async (_, { rejectWithValue }) => {
    try {
      const response = await instance.get(
        "/crm/leads/fetch-cmo-employee-list"
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || {
          message: "Failed to fetch source employees.",
        }
      );
    }
  }
);

export const getNoteList = createAsyncThunk("getNoteList", async (id) => {
  try {
    const response = await instance.get(`/crm/leads/fetch-lead-note?lead_id=${id}`);
    return response?.data;
  } catch (error) {
    return error;
  }
});

export const getAllProject = createAsyncThunk("getAllProject", async () => {
  try {
    const response = await instance.get("/crm/project/fetch-all-projects");
    return response?.data;
  } catch (error) {
    return error;
  }
});
export const getEmployeeList = createAsyncThunk("getEmployeeList", async (body) => {
  try {
    const response = await instance.get(`/crm/project/get-employee-by-project?project_id=${body?.project_id}`);
    return response?.data;
  } catch (error) {
    return error;
  }
});

export const getAllEmployeeByProjectId = createAsyncThunk("getAllEmployeeByProjectId", async (body) => {
  try {
    const response = await instance.get(`/crm/project/get-employee-by-project?project_id=${body?.project_id}&include_ex_emp=${body?.include_ex_emp}`);
    return response?.data;
  } catch (error) {
    return error;
  }
});

export const fetchCallingStatus = createAsyncThunk("fetchCallingStatus", async (body) => {
  try {

    const response = await instance.get("/crm/filter-master/fetch-all-calling-status");
    return response?.data;
  } catch (error) {
    return error;
  }
});

export const AddLeadUpdate = createAsyncThunk("AddLeadUpdate", async (body) => {
  try {

    const response = await instance.post(`/crm/leads/lead-update-by-excuters?lead_id=${body?.lead_id}`, body?.data);
    return response?.data;
  } catch (error) {
    return error;
  }
})

export const AddLeadStatusUpdate = createAsyncThunk("AddLeadStatusUpdate", async (body) => {
  try {

    const response = await instance.post(`/crm/leads/lead-update-by-excuters?lead_id=${body?.lead_id}`, body?.data);
    return response?.data;
  } catch (error) {
    return error;
  }
})

export const fetchLeadStatus = createAsyncThunk("fetchLeadStatus", async (body) => {
  try {

    const response = await instance.get(`/crm/recycle-lead/fetch-lead-by-excuter?lead_status=${body.lead_status}`);
    return response?.data;
  } catch (error) {
    return error;
  }
});
export const fetchBalanceLead = createAsyncThunk("fetchBalanceLead", async (body) => {
  try {

    const response = await instance.get("/crm/recycle-lead/fetch-lead-stor-balance");
    return response?.data;
  } catch (error) {
    return error;
  }
});

export const getUtmSourceList = createAsyncThunk("getUtmSourceList", async () => {
  try {
    const response = await instance.get("/crm/filter-master/fetch-all-utm-source");
    return response.data;
  } catch (error) {
    throw error;
  }
});

export const LeadSlice = createSlice({
  name: "LeadSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(GetLeadData.pending, (state, action) => {
      // state.leadData = null;
      state.loading = true;
      state.response = null;
      state.leadRequestId = action.meta.requestId;
    });
    builder.addCase(GetLeadData.fulfilled, (state, action) => {
      if (state.leadRequestId !== action.meta.requestId) return;
      state.loading = false;
      state.leadData = action.payload;
      state.leadRequestId = null;
    });
    builder.addCase(GetLeadData.rejected, (state, action) => {
      if (state.leadRequestId !== action.meta.requestId) return;
      state.loading = false;
      state.error = action.error;
      state.leadData = action.payload;
      state.leadRequestId = null;
    });

    builder.addCase(AddLeadFile.pending, (state) => {
      state.loading = true;
      state.response = null;
    });
    builder.addCase(AddLeadFile.fulfilled, (state, action) => {
      state.loading = false;
      state.response = action.payload;
    });
    builder.addCase(AddLeadFile.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
      state.response = null;
    });

    builder.addCase(getSingleLead.pending, (state) => {
      state.loading = true;
      state.response = null;
    });
    builder.addCase(getSingleLead.fulfilled, (state, action) => {

      state.loading = false;
      state.singleLead = action.payload;
    });
    builder.addCase(getSingleLead.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
      state.response = null;
    });

    builder.addCase(createLead.pending, (state) => {
      state.loading = true;
      state.response = null;
    });
    builder.addCase(createLead.fulfilled, (state, action) => {
      state.loading = false;
      state.response = action.payload;
    });
    builder.addCase(createLead.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
      state.response = null;
    });

    builder.addCase(AddAlternativeNumber.pending, (state) => {
      state.loading = true;
      state.response = null;
    });
    builder.addCase(AddAlternativeNumber.fulfilled, (state, action) => {
      state.loading = false;
      state.alterData = action.payload;
    });
    builder.addCase(AddAlternativeNumber.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
      state.response = null;
    });

    builder.addCase(UpdateLead.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(UpdateLead.fulfilled, (state, action) => {
      state.loading = false;
      state.response = action.payload;
    });
    builder.addCase(UpdateLead.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
      state.response = null;
    });

    builder.addCase(callCountUpdate.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(callCountUpdate.fulfilled, (state, action) => {
      state.loading = false;
      // state.response = action.payload;
      state.callList = action.payload;

    });
    builder.addCase(callCountUpdate.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
      state.response = null;
    });

    builder.addCase(checkStatusInstall.pending, (state) => {
      state.checkStatusInstall = true;
    });
    builder.addCase(checkStatusInstall.fulfilled, (state, action) => {
      state.checkStatusInstall = false;
      state.response = action.payload;
    });
    builder.addCase(checkStatusInstall.rejected, (state, action) => {
      state.checkStatusInstall = false;
      state.error = action.error;
      state.response = null;
    });

    builder.addCase(getHistory.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getHistory.fulfilled, (state, action) => {
      state.loading = false;
      state.response = action.payload;
    });
    builder.addCase(getHistory.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    });
    //CONVERT LEAD
    builder.addCase(convertLead.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(convertLead.fulfilled, (state, action) => {
      state.loading = false;
      state.response = action.payload;
    });
    builder.addCase(convertLead.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    });
    //REMINDER DATE UPDATE
    builder.addCase(UpdateReminderDate.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(UpdateReminderDate.fulfilled, (state, action) => {

      state.loading = false;
      state.conLead = action.payload;
    });
    builder.addCase(UpdateReminderDate.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    });

    //SEND TEMPLATE BULK NUMBERS----
    builder.addCase(sendMultipleTemplate.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(sendMultipleTemplate.fulfilled, (state, action) => {
      state.loading = false;
      state.response = action.payload;
    });
    builder.addCase(sendMultipleTemplate.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    });

    builder.addCase(fetchSingleLeadTrack.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchSingleLeadTrack.fulfilled, (state, action) => {

      state.loading = false;
      state.leadTrack = action.payload;
    });
    builder.addCase(fetchSingleLeadTrack.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    });
    builder.addCase(AddLeadDescription.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(AddLeadDescription.fulfilled, (state, action) => {
      state.loading = false;
      state.leadDesc = action.payload;
    });
    builder.addCase(AddLeadDescription.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    });

    //source List
    builder.addCase(getSourceList.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSourceList.fulfilled, (state, action) => {

      state.loading = false;
      state.sourceList = action.payload;
    });
    builder.addCase(getSourceList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    });
    //notes List
    builder.addCase(getNoteList.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getNoteList.fulfilled, (state, action) => {

      state.loading = false;
      state.noteList = action.payload;
    });
    builder.addCase(getNoteList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    });

    // {emmployee list}
    builder.addCase(getEmployeeList.pending, (state) => {
      state.loading = true;
      state.response = null;
    });
    builder.addCase(getEmployeeList.fulfilled, (state, action) => {
      state.loading = false;
      state.employee = action.payload;
    });
    builder.addCase(getEmployeeList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;

    });

    // {get-employee-by-project}
    builder.addCase(getAllProject.pending, (state) => {
      state.loading = true;
      state.response = null;
    });
    builder.addCase(getAllProject.fulfilled, (state, action) => {
      state.loading = false;
      state.projectsList = action.payload;
    });
    builder.addCase(getAllProject.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;

    });

    builder.addCase(fetchCallingStatus.pending, (state) => {
      state.loading = true;

    });
    builder.addCase(fetchCallingStatus.fulfilled, (state, action) => {
      state.loading = false;
      state.callingStatus = action.payload;
    });
    builder.addCase(fetchCallingStatus.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;

    });
    builder.addCase(AddLeadUpdate.pending, (state) => {
      state.loading = true;
      state.response = null;
    });
    builder.addCase(AddLeadUpdate.fulfilled, (state, action) => {
      state.loading = false;
      state.response = action.payload;
    });
    builder.addCase(AddLeadUpdate.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
      state.response = null;
    });

    builder.addCase(AddLeadStatusUpdate.pending, (state) => {
      state.loading = true;
      state.response = null;
    });
    builder.addCase(AddLeadStatusUpdate.fulfilled, (state, action) => {
      state.loading = false;
      state.response = action.payload;
    });
    builder.addCase(AddLeadStatusUpdate.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
      state.response = null;
    });

    builder.addCase(fetchLeadStatus.pending, (state) => {
      state.loading = true;
      state.leadStatus = null;
    });
    builder.addCase(fetchLeadStatus.fulfilled, (state, action) => {
      state.loading = false;
      state.leadStatus = action.payload;
    });
    builder.addCase(fetchLeadStatus.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
      state.leadStatus = null;
    });

    builder.addCase(fetchBalanceLead.pending, (state) => {
      state.loading = true;
      state.leadBalance = null;
    });
    builder.addCase(fetchBalanceLead.fulfilled, (state, action) => {
      state.loading = false;
      state.leadBalance = action.payload;
    });
    builder.addCase(fetchBalanceLead.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
      state.leadBalance = null;
    });

    builder.addCase(getUtmSourceList.pending, (state) => {
      state.loading = true;
      state.utmSource = null;
    });
    builder.addCase(getUtmSourceList.fulfilled, (state, action) => {
      state.loading = false;
      state.utmSource = action.payload;
    });
    builder.addCase(getUtmSourceList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
      state.utmSource = action.payload;
    });
  },
});

export default LeadSlice.reducer;
